import axios from 'axios'
import camelcaseKeys from 'camelcase-keys'
import snakecaseKeys from 'snakecase-keys'
import { API_CONFIG } from '@/lib/constants'
import { useNotice } from '@/components/common/Notice.vue'

const baseURL = '/api'

// https://github.com/axios/axios/issues/1109#issuecomment-344400595
const defaultTransformeRequests = () => {
  const { transformRequest } = axios.defaults
  if (!transformRequest) {
    return []
  } else if (transformRequest instanceof Array) {
    return transformRequest
  } else {
    return [transformRequest]
  }
}

const defaultTransformeResponse = () => {
  const { transformResponse } = axios.defaults
  if (!transformResponse) {
    return []
  } else if (transformResponse instanceof Array) {
    return transformResponse
  } else {
    return [transformResponse]
  }
}

export const http = axios.create({
  ...API_CONFIG,
  baseURL,
  transformResponse: [
    ...defaultTransformeResponse(),
    data => {
      if (!data) {
        return
      }

      return camelcaseKeys(data, { deep: true })
    },
  ],
  transformRequest: [
    (data, headers) => {
      if (!data) {
        return
      }

      headers = headers || {}

      headers['Content-Type'] = 'application/json'

      if (data.camelcaseKeys) {
        delete data.camelcaseKeys

        return data
      }

      return snakecaseKeys(data)
    },
    ...defaultTransformeRequests(),
  ],
})

http.interceptors.response.use(
  response => response,
  error => {
    if (!error.response) {
      return Promise.reject(error)
    }

    const {
      response: { status },
    } = error

    const notice = useNotice()

    if (status === 400) {
      notice.show('不正なリクエストです。')
    } else if (status === 401) {
      notice.show('認証エラー')
      // ここでは、vue-routerのuseRouterは使えないのでhrefを代わりに使う
      if (!/\/admin\/login$/.test(window.location.href)) {
        location.href = '/admin/login'
      }
    } else if (status === 404) {
      notice.warn('データが存在しません。')
    } else if (status === 502) {
      // location.href = '/reboot_message.html'
    } else {
      notice.error('システムエラー')
    }

    return Promise.reject(error)
  }
)
